import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
// const ics = require('ics')
// const {google} = require('googleapis');
// import Login from './login/login.component.jsx';
import Signup from './login/signup';
import Signin from './login/login';
import Forgot from './common/forgotPassword';
import ActivateAccount from './common/accountActivation';
import ResetPassword from './common/resetPassword'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './marketing/home';
import Blog from './marketing/blog';
import UnLockAccount from './common/unlockAccount';
import UnsubscribeEmails from './common/unsubscribeEmails';
import OtpModal from './login/otp';
import { Button } from 'react-bootstrap';
import openSocket from "socket.io-client";
import * as url from "../tools/config";
import 'antd/dist/antd.css';


const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
// import { history } from '../store/configureStore';
// import { withRouter, Redirect } from "react-router-dom";
// import AdminAuth from './admin/auth/adminauth.component';
var countries = require('country-data').countries

// import '../customScrollBar.js';

// This is a class-based component because the current
// component at the top-level.
class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			signUpModelOpen: false,
			signInModelOpen: false,
			activateAccountModalOpen: false,
			resetModalOpen: false,
			isLoader: true,
			isHome: false,
			isBlog: false,
			howItWork: false,
			issearchSpeciality: false,
			resetkey: '',
			activationKey: '',
			emailToken: '',
			unLockAccountModalOpen: false,
			unSubscribeEmailModalOpen: false,
			unlockKey: '',
			key: '',
			adminAuth: false,
			otpModalOpen: false,
			loginData: {}

		};
		this.openSignInModal = this.openSignInModal.bind(this);
		this.hideSigninModal = this.hideSigninModal.bind(this);
		this.openSignUpModal = this.openSignUpModal.bind(this);
		this.hideSignupModal = this.hideSignupModal.bind(this);
		this.closeSignupOpenSignin = this.closeSignupOpenSignin.bind(this);
		this.closeSigninOpenSignup = this.closeSigninOpenSignup.bind(this);
		this.openForgotModal = this.openForgotModal.bind(this);
		this.openOtpModal = this.openOtpModal.bind(this);
		this.closeOtpModal = this.closeOtpModal.bind(this);
		this.hideForgotModal = this.hideForgotModal.bind(this);
		this.closeForgotModal = this.closeForgotModal.bind(this);
		this.closeActivateOpenSigin = this.closeActivateOpenSigin.bind(this);
		this.closeResetOpenSigin = this.closeResetOpenSigin.bind(this);
		this.closeActive = this.closeActive.bind(this);
		this.closeReset = this.closeReset.bind(this);
		this.openBlog = this.openBlog.bind(this);
		this.openHome = this.openHome.bind(this);
		this.openUnLockAccountModal = this.openUnLockAccountModal.bind(this);
		this.openUnsubscribeModal = this.openUnsubscribeModal.bind(this);

		this.closeUnLockAccountModal = this.closeUnLockAccountModal.bind(this);
		this.closeUnsubscribeModal = this.closeUnsubscribeModal.bind(this);

		this.closeUnLockAccountOpenSigin = this.closeUnLockAccountOpenSigin.bind(this);
		this.goToSpecialistSearch = this.goToSpecialistSearch.bind(this);
		this.howItWorkEnable = this.howItWorkEnable.bind(this);



	}
	goToSpecialistSearch() {
		navigator.geolocation.getCurrentPosition(
			function (position) { // success cb
				var lat = position.coords.latitude;
				var lng = position.coords.longitude;
				localStorage.setItem('lat', lat);
				localStorage.setItem('lng', lng);
			},
			function () { // fail cb
				localStorage.setItem('lat', 0);
				localStorage.setItem('lng', 0);
			}
		);
		this.setState({
			isHome: false
		})
		this.props.history.push('/marketing/search-specialist');
	}
	openBlog() {
		this.setState({ isBlog: true, isHome: false })
	}
	openHome() {
		this.setState({ isBlog: false, isHome: false, howItWork: false })
	}

	componentWillMount() {
		var user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
		var userId = localStorage.getItem("userId") ? localStorage.getItem("userId") : {};
		
		// debugger;
		if (!user && !userId) {
			this.props.history.push('/')
		} else {
			console.log("+++...useridfd", user, userId)
			// socket.emit("adduser", { userId  });
		}
		if (this.props.location.pathname == '/') {
			if (user.type === 'patient')
				this.props.history.push('/dashboard')
			if (user.type === 'specialist')
				this.props.history.push('/specialist/my-appointment')
			if (user.role_id && user.role_id.status == 3)
				this.props.history.push('/user/superuser-dashboard')
		}
		if (this.props.match.params.activationKey) {

			this.setState({ activateAccountModalOpen: true, activationKey: this.props.match.params.activationKey })
		} else if (this.props.match.params.resetkey) {
			this.setState({ resetModalOpen: true, resetkey: this.props.match.params.resetkey })
		} else if (this.props.match.params.emailToken) {

			this.setState({ signInModelOpen: true, emailToken: this.props.match.params.emailToken });

		} else if (this.props.match.params.unlockKey) {
			this.setState({ unLockAccountModalOpen: true, unlockKey: this.props.match.params.unlockKey });
		}
		else if (this.props.match.params.key) {
			this.setState({ unSubscribeEmailModalOpen: true, key: this.props.match.params.key });
		}/* else if(user != null){
			this.props.history.push('/dashboard')
			// <Redirect to="/dashboard" />
		} */

	}
	componentDidMount() {
		
		this.setState({ isLoader: false });
		localStorage.setItem('isDisclaimerBlog', true);

		if (localStorage.getItem('availabilityId') && (localStorage.getItem('availabilityId') != null && localStorage.getItem('availabilityId') != '') && localStorage.getItem('fromMarketPage') && (localStorage.getItem('fromMarketPage') != null && localStorage.getItem('fromMarketPage') != false)) {
			this.setState({ signInModelOpen: true });

		}
		navigator.geolocation.getCurrentPosition(
			function (position) {

				var lat = position.coords.latitude;
				var lng = position.coords.longitude;

				localStorage.setItem('lat', lat);
				localStorage.setItem('lng', lng);
				axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
					.then(function (response) {
						if (response) {

							for (var i = 0; i < response.data.results.length; i++) {
								if (response.data.results[i].types[0] == 'country') {
									var countryshort = response.data.results[i].address_components[0].short_name;
									var countrylong = response.data.results[i].address_components[0].long_name;





									localStorage.setItem('country_short', countryshort)
									localStorage.setItem('country_long', countrylong)
									localStorage.setItem('Currentcountry', countrylong)

									localStorage.setItem('currency', countries[countryshort].currencies[0]);
									localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
									localStorage.removeItem('mileDistance', 0)
								}
							}
						}
						// else {
						// }
					})
			});
	}

	openSignUpModal(userType) {
		localStorage.setItem('userType', userType)
		this.setState({ signUpModelOpen: true })
	}
	hideSignupModal(e) {
		this.setState({ signUpModelOpen: false });
		// e.preventDefault()

	}

	openSignInModal(userType) {
		localStorage.setItem('userType', userType)
		this.setState({ signInModelOpen: true });
	}
	hideSigninModal() {
		this.setState({ signInModelOpen: false });
		localStorage.removeItem('fromMarketPage');
	}
	closeSignupOpenSignin() {
		this.setState({ signUpModelOpen: false, signInModelOpen: true }, () => {

		})
	}
	closeSigninOpenSignup() {
		this.setState({ signUpModelOpen: true, signInModelOpen: false }, () => {

		})
	}
	openForgotModal() {

		this.setState({ forgotModalOpen: true, signInModelOpen: false });
	}

	closeForgotModal() {
		this.setState({ forgotModalOpen: false, signInModelOpen: true });
	}
	openOtpModal(data) {
		// debugger
		this.setState({ otpModalOpen: true, signInModelOpen: false, loginData: data }, () => {

		});
	}
	closeOtpModal() {
		this.setState({ otpModalOpen: false, signInModelOpen: false });
	}
	hideForgotModal() {
		this.setState({ forgotModalOpen: false });

	}
	closeActivateOpenSigin() {
		this.setState({ signInModelOpen: true, activateAccountModalOpen: false }, () => {

		})
	}
	closeResetOpenSigin() {
		this.setState({ resetModalOpen: false })
		this.props.history.push('/')
	}
	closeActive() {
		this.setState({ activateAccountModalOpen: false })
		this.props.history.push('/');
	}
	closeReset() {
		this.setState({ resetModalOpen: false })
		this.props.history.push('/')
	}

	openUnLockAccountModal() {
		this.setState({ unLockAccountModalOpen: true });
	}
	openUnsubscribeModal() {
		this.setState({ unSubscribeEmailModalOpen: true });
	}
	closeUnLockAccountModal() {
		this.setState({ unLockAccountModalOpen: false })
		this.props.history.push('/');
	}
	closeUnsubscribeModal() {
		this.setState({ unSubscribeEmailModalOpen: false })
		this.props.history.push('/');
	}
	closeUnLockAccountOpenSigin() {
		this.setState({ signInModelOpen: true, unLockAccountModalOpen: false })
	}
	howItWorkEnable() {
		this.setState({ howItWork: true, isHome: false });
	}


	render() {
		// 
		

		return (
			<div>
				{this.state.isLoader ? <ReactLoading type={'bars'} color={'blue'} /> :
					<div>
						<nav className="navbar navbar-expand-md  navbar-default fixed-top navbar-fixed-top sticky">
							<Link to="/" className="navbar-brand logo" href="#">
								<img src={require('../images/images/logo.svg')} width="185" alt="" />
							</Link>
							<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
								<span className="navbar-toggler-icon"><i className="fa fa-align-justify"></i></span>
							</button>

							<div className="collapse navbar-collapse flex-row-reverse" id="navbarSupportedContent">
								<ul className=" navbar-nav navbar-right ">
									<li
										className={(this.state.isHome) ? 'nav-item active' : 'nav-item'} style={{ 'cursor': 'pointer' }}
									>
										<Link /* onClick={this.openHome} */ to="/" onClick={this.ICS}>Home</Link>
									</li>
									{/* <li className={(this.state.howItWork) ? 'nav-item active' : 'nav-item'} >
										<Link href="/how-it-works" onClick={this.howItWorkEnable}>How it Works</Link>
									</li> */}
									<li className="nav-item ">
										<Link to="/marketing/how-it-works">
											How it Works</Link>
									</li>
									<li className="nav-item ">
										<Link to="/marketing/hospital">
											Hospital</Link>
									</li>

									<li className={(this.state.issearchSpeciality) ? 'nav-item active' : 'nav-item'}>
										<Link to='/marketing/for-specialist'
										//  onClick={this.goToSpecialistSearch} style={{ cursor: "pointer" }}
										>For Specialists</Link>
									</li>
									<li className="nav-item ">
										<Link to="/marketing/services">
											Services</Link>
									</li>
									<li className={(this.state.isBlog) ? 'nav-item active' : 'nav-item'} style={{ 'cursor': 'pointer' }}>
										<Link to="/marketing/blogs">Blog</Link>
									</li>
									<li className="nav-item ">
										<Link to="#" onClick={this.openSignUpModal.bind(this, '1')} className="btn btn-primary btn-signup" >Sign Up</Link>
									</li>
									<li className="nav-item ">
										<Link to="#" onClick={this.openSignInModal.bind(this, '1')} className="btn btn-signin btn-signup" >
											<span className="signin-icon">
												<img src={require('../images/images/signin_icon.png')} alt="" />
											</span>Sign In</Link>
										{this.state.signInModelOpen ?
											<Signin {...this.props} openModal={this.state.signInModelOpen} hideSigninModal={this.hideSigninModal} closeSigninOpenSignup={this.closeSigninOpenSignup} openForgotModal={this.openForgotModal} emailToken={this.state.emailToken} otpModal={this.openOtpModal} {...this.props} /> : ''}

										{/* <AdminAuth  /> */}
										{this.state.otpModalOpen ?
											<OtpModal otpModalOpen={this.state.otpModalOpen} loginData={this.state.loginData} closeOtpModal={this.closeOtpModal} {...this.props} /> : ''}

										{this.state.signUpModelOpen ?
											<Signup {...this.props} show={this.state.signUpModelOpen} hideSignupModal={this.hideSignupModal} closeSignupOpenSignin={this.closeSignupOpenSignin} /> : ''}

										{/* <AdminAuth /> */}

										{this.state.forgotModalOpen ?
											<Forgot forgotModalOpen={this.state.forgotModalOpen} hideForgotModal={this.hideForgotModal} closeForgotModal={this.closeForgotModal} {...this.props} /> : ''}
										{this.state.activateAccountModalOpen ?
											<ActivateAccount activateModalOpen={this.state.activateAccountModalOpen} closeActivateOpenSigin={this.closeActivateOpenSigin} activationKey={this.state.activationKey} closeActive={this.closeActive} {...this.props} /> : ''}

										{this.state.resetModalOpen ?
											<ResetPassword  resetModalOpen={this.state.resetModalOpen} closeResetOpenSigin={this.closeResetOpenSigin} resetkey={this.state.resetkey} closeReset={this.closeReset}  {...this.props} /> : ''}

										{this.state.unLockAccountModalOpen ?
											<UnLockAccount unLockModalOpen={this.state.unLockAccountModalOpen} closeUnLockAccountOpenSigin={this.closeUnLockAccountOpenSigin} unLockKey={this.state.unlockKey} closeUnLock={this.closeUnLockAccountModal} {...this.props} /> : ''}
										{this.state.unSubscribeEmailModalOpen ?
											<UnsubscribeEmails unSubscribeEmails={this.state.unSubscribeEmailModalOpen} closeUnSubscribeOpenSigin={this.closeUnLockAccountOpenSigin} unSubscribekey={this.state.key} closeunSubscribeEmails={this.closeUnsubscribeModal} {...this.props} /> : ''}

									</li>
								</ul>
							</div>
						</nav>
						{this.state.isHome ? '' : <Home openSignUp={this.openSignUpModal.bind(this, '1')} {...this.props} />}
						{this.state.isBlog ? <Blog {...this.props} /> : ''}
						<ToastContainer {...this.props} />
						<footer className="text-center colorFooter">
							<div className="container">
								<div className="row">
									<div className="col-sm-12">
										<ul className="foterList">
											<li className="b-r">
												<Link to="#">
													<img src={require('../images/images/footer_logo.png')} className="m-b-15" alt="" />
												</Link>
												<Link to="/apps">
													<img src={require('../images/images/appstore_footer.png')} className="m-b-10" alt="" />
												</Link>
												<Link to="/apps">
													<img src={require('../images/images/playstore_Footer.png')} alt="" />
												</Link>
											</li>
											<li className="b-r">
												<div className="listCompanyItem">
													<h4>Our Company</h4>
													<ul className="CompnayList">
														<li>
															<Link to="/marketing/about-us">About us</Link>
														</li>
														<li>
															<Link to="/marketing/contact-us">Contact Us</Link>
														</li>
														<li>
															<Link to="/marketing/terms">Terms &amp; Conditions</Link>
														</li>
														<li>
															<Link to="/marketing/privacy">Privacy Policy</Link>
														</li>
														<li>
															<Link to="/marketing/quality">Quality &amp; Transparency</Link>
														</li>
														<li>
															<Link to="/marketing/support-centre">Support Centre</Link>
														</li>
													</ul>
												</div>
											</li>
											<li className="b-r">
												<div className="ft-link-block listCompanyItem">
													<h4>For Patients</h4>
													<ul className="CompnayList">
														<li>
															<Link to="#" onClick={this.openSignInModal.bind(this, '1')} to="">Sign In</Link>
														</li>
														<li>
															<Link to="#" onClick={this.openSignUpModal.bind(this, '1')} to="">Sign Up</Link>
														</li>
														<li>
															<Link to="#">Find a Specialist </Link>
														</li>
														<li>
															<Link to="/#Benifits">Benefits of the ER App</Link>
														</li>
													</ul>
												</div>

											</li>
											<li className="b-r">
												<div className="ft-link-block listCompanyItem">
													<h4>For Specialists</h4>
													<ul className="CompnayList">
														<li>
															<Link to="#" onClick={this.openSignInModal.bind(this, '2')} to="">Sign In</Link>
														</li>
														<li>
															<Link to="#" onClick={this.openSignUpModal.bind(this, '2')} to="">Sign Up</Link>
														</li>
														<li>
															<Link to="#" href="for-specialist/#Joinus">Why Join Us?</Link>
														</li>

													</ul>
												</div>
											</li>
											<li>
												<div className="ft-link-block listCompanyItem">
													<h4>Apps</h4>
													<ul className="CompnayList">
														<li>
															<Link to="/marketing/apps">Patient Android App</Link>
														</li>
														<li>
															<Link to="/marketing/apps">Patient iOS App</Link>
														</li>
														<li>
															<Link to="/marketing/apps">Specialists Android App </Link>
														</li>
														<li>
															<Link to="/marketing/apps">Specialists iOS App</Link>
														</li>
													</ul>
												</div>
											</li>
										</ul>
									</div></div>
								<div className="row">
									<div className="col-sm-12 text-center">
										<ul className="list-inline social-icon">
											<li className="m-5">
												<Link to="#">
													<i className="fa fa-facebook"></i>
												</Link>
											</li>
											<li className="m-5">
												<Link to="#">
													<i className="fa fa-twitter"></i>
												</Link>
											</li>
											<li className="m-5">
												<Link to="#">
													<i className="fa fa-google"></i>
												</Link>
											</li>
											<li className="m-5">
												<Link to="#">
													<i className="fa fa-pinterest-p"></i>
												</Link>
											</li>
											<li className="m-5">
												<Link to="#">
													<i className="fa fa-linkedin"></i>
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="copyright">
								<div className="">
									<div className="">
										{/* <p className="copyTxt">Copyright &copy; MyCompany. All rights reserved.</p> */}
										<p className="copyTxt">Medfix © 2018. All rights reserved.</p>
									</div>
								</div>
							</div>
						</footer>
					</div>
				}
			</div>
			// </Loader>
		);
	}
}


export default Index;
